import React from "react";
import { Share2, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  BackButton,
  Container,
  Content,
  Footer,
  HeroImage,
  Meta,
  ShareButton,
  Title,
  Wrapper,
} from "./LifeInsuranceIn2026";

const TermInsuranceBlog = () => {
  const navigate = useNavigate();

  const blog = {
    title: "Why Term Insurance is a Must-Have",
    author: "Manoj",
    date: "March 15, 2026",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f",
  };

  const handleShare = async () => {
    const shareData = {
      title: blog.title,
      text: "Check out this article",
      url: window.location.href,
    };

    if (navigator.share) {
      await navigator.share(shareData);
    } else {
      await navigator.clipboard.writeText(shareData.url);
      alert("Link copied!");
    }
  };

  return (
    <Container>
      <Wrapper>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={18} /> Back
        </BackButton>

        <Title>{blog.title}</Title>
        <Meta>
          {blog.date} • {blog.author}
        </Meta>

        <HeroImage src={blog.image} />

        <Content>
          <p>
            Term insurance is one of the simplest and most affordable forms of
            life insurance. Yet, it remains one of the most powerful financial
            tools.
          </p>

          <h2>What is Term Insurance?</h2>
          <p>
            It provides pure life cover for a specific period. If something
            happens to you during the term, your family receives a payout.
          </p>

          <h2>Why is it Important?</h2>
          <p>
            It ensures your family can handle expenses like loans, education,
            and daily living even in your absence.
          </p>

          <h2>Key Advantages</h2>
          <ul>
            <li>High coverage at low premium</li>
            <li>Simple and easy to understand</li>
            <li>Financial security for dependents</li>
          </ul>

          <h2>Who Should Buy It?</h2>
          <p>
            Anyone with financial dependents — especially working professionals,
            parents, and business owners.
          </p>

          <h2>Final Thoughts</h2>
          <p>
            Term insurance is not optional — it’s essential. It’s one of the
            smartest financial decisions you can make.
          </p>
        </Content>

        <Footer>
          <ShareButton onClick={handleShare}>
            <Share2 size={18} /> Share
          </ShareButton>
        </Footer>
      </Wrapper>
    </Container>
  );
};

export default TermInsuranceBlog;
